import React, { useContext, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import UnauthorizedPage from '@@/products/portal/pages/unauthorized-access-page';
import { AccessManagementPermission, accessManagementPermissionMapping } from '../common/permission-mappings';
import { Box, Spinner } from '@cloudscape-design/components';
import { determineUserPermissions } from '@@/lib/permissions';
import { AuthContext } from '@@/contexts/AuthContext';

const AccessManagementAuthorizer = () => {
  const { instanceData, loading, error } = useContext(AuthContext);
  const { pathname } = useLocation();

  const userPermissions = useMemo(() => {
    if (!instanceData?.permissions) return new Set<AccessManagementPermission>();
    return determineUserPermissions(instanceData.permissions, pathname, accessManagementPermissionMapping);
  }, [instanceData?.permissions, pathname]);

  if (loading) {
    return (
      <Box padding='xxl' textAlign='center'>
        <Spinner size='large' />
      </Box>
    );
  }

  if (error) {
    return <div aria-label={'API Error'}>API Error: {error.toString()}</div>;
  }

  if (userPermissions && userPermissions.size > 0) {
    return <Outlet context={{ permissions: userPermissions }} />;
  }

  return <UnauthorizedPage />;
};

export default AccessManagementAuthorizer;
